/* ==========================================================================
   Calendar > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');
const InputClient = require('../../../input/client/js');
const prototype = require('./prototype');
const config = require('./config');

/**
 * Calendar component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function Calendar(selector = '[data-component="Calendar"]', configuration = {}) {
    if (elementExist(selector)) {
        // Extend the proto input base with specific methods
        const instance = Object.create(prototype);

        // Element reference
        instance.element = document.querySelector(selector);

        // Config
        instance.config = {
            ...config,
            ...configuration,
            context: JSON.parse(instance.element.dataset.context)
        };

        // Input reference
        instance.input = InputClient(`${selector} [data-component="Input"]`, {
            ...configuration.input,
            autoSelect: false
        });

        // Id reference
        instance.id = randomId(randomId('calendar'));

        // Set defaultdate
        instance.config.defaultDate = instance.element.dataset.defaultdate || undefined;

        // Init error handler
        instance.error = false;

        // Value reference
        instance.value = instance.input.get();

        // Auto init
        if (instance.config.init) instance.init();

        return instance;
    }
};
